import PropTypes from "prop-types";
import React from "react";

import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { PROVIDER_DETAIL_STYLES } from "../../styles";

export default function ProviderDetailVisibilityToggle({
  isVisible,
  onToggle,
  sectionName,
  toggleId,
}) {
  return (
    <button
      id={toggleId}
      type="button"
      aria-label={`${isVisible ? "Hide" : "Show"} ${sectionName}`}
      style={PROVIDER_DETAIL_STYLES.sectionVisibilityToggle}
      onClick={onToggle}
    >
      <span style={PROVIDER_DETAIL_STYLES.sectionVisibilityToggleLabel}>
        {isVisible ? "Hide" : "Show"}
      </span>
      <span style={PROVIDER_DETAIL_STYLES.sectionVisibilityToggleIconPane}>
        <Svg
          name={isVisible ? SvgEnum.HisEyeOff : SvgEnum.HisEye}
          color={HNSColors.neutrals[900]}
          sx={{ width: 18, height: 18 }}
        />
      </span>
    </button>
  );
}

ProviderDetailVisibilityToggle.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  sectionName: PropTypes.string.isRequired,
  toggleId: PropTypes.string.isRequired,
};
